
import { toast } from 'react-toastify';
import './toastify.css';

const SuccessAlert = ({message, position}) => {
    toast.success(message, {
      position: position,
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
}

export default SuccessAlert;